import { generic_order_status_options } from "common/filters";
import type { Milestone } from "../types/order";

export default function MilestoneTracker({
  milestones,
}: {
  milestones?: Milestone[];
}) {
  const sortedMilestones = [...(milestones || [])]
    .sort((a, b) => {
      // First, sort by priority (ascending)
      if (a.priority !== b.priority) {
        return a.priority - b.priority;
      }

      // If same priority, remove the one with "Inactive" status
      if (a.status === "Inactive" && b.status !== "Inactive") {
        return 1; // b comes first (a is filtered out later)
      }
      if (b.status === "Inactive" && a.status !== "Inactive") {
        return -1; // a comes first (b is filtered out later)
      }

      return 0; // same status or both Active
    })
    // Filter out Inactive milestones ONLY if they share priority with another
    .filter((milestone, index, arr) => {
      // Check if there's another milestone with the same priority
      const hasSamePriority = arr.some(
        (m, i) => i !== index && m.priority === milestone.priority
      );

      // Keep milestone if:
      // - It's not Inactive, OR
      // - No other milestone shares its priority (so we don't filter standalone Inactive milestones)
      return !(milestone.status === "Inactive" && hasSamePriority);
    });

  console.log("Sorted Milestones:", sortedMilestones);

  return (
    <div className="flex flex-col w-full h-full mt-5">
      {sortedMilestones.map((milestone, idx) => {
        // Determine milestone status
        const isCompleted = milestone.status === "Fulfilled";
        const isActive = milestone.status === "Active";
        const isRejected = milestone.stage === "Order Rejected";

        // Color logic
        const dotColor = isRejected
          ? "border-red-500 bg-red-500"
          : isCompleted
          ? "border-[#00A82D] bg-[#00A82D]"
          : isActive
          ? "border-[#083990] bg-[#083990]"
          : "border-[#626262] bg-[#626262]";

        const lineColor = isRejected
          ? "bg-[#ee4236e0]"
          : isCompleted
          ? "border-[#00A82D]"
          : isActive
          ? "border-[#083990]"
          : "bg-gray-300";

        // Calculate line height based on content
        const hasSubStages =
          milestone.sub_stages && milestone.sub_stages.length > 0;

        // const colors = generic_order_status_options.find(
        //     (status) => status.label.toLowerCase() === milestone?.stage.toLowerCase()
        //   );

        return (
          <div
            key={milestone.milestone_id}
            className="flex items-start gap-3 relative"
          >
            <div className="flex flex-col items-center">
              <div
                className={`w-4 h-4 rounded-full border-2 ${dotColor} z-10`}
              ></div>
              {idx < sortedMilestones.length - 1 && (
                <div
                  className={` border-[1.5px] ${lineColor} flex-grow`}
                  style={{
                    height: hasSubStages ? "calc(100% - 8px)" : "50px",
                    marginTop: -8,
                    position: hasSubStages ? "absolute" : "relative",
                    top: hasSubStages ? "16px" : "auto",
                    bottom: hasSubStages ? "0" : "auto",
                  }}
                ></div>
              )}
            </div>
            <div className="flex-1">
              <div
                // style={{
                //   color: isRejected ? '#ef4444' : colors?.value || '#626262',
                // }}
                className={`font-medium ${
                  isRejected
                    ? "text-red-500"
                    : isCompleted || isActive
                    ? "text-[#083990]"
                    : "text-gray-400"
                }`}
              >
                {milestone.stage}
              </div>

              {/* Latest timestamp for the milestone */}
              {/* <div className="text-xs text-gray-400 mb-1">
                {milestone.sub_stages && milestone.sub_stages[0]?.created_at
                  ? new Date(milestone.sub_stages[0].created_at).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : ""}
              </div> */}

              {/* Display all sub-stages */}
              {/* {hasSubStages && (
                <div className="ml-2 mt-2 space-y-2">
                  {milestone.sub_stages.map((subStage, subIdx) => (

                  ))}
                </div>
              )} */}
              {hasSubStages && (
                <div className="ml-2 my-2 space-y-2">
                  <div className="py-1">
                    {/* <div
                      className={`text-sm font-medium ${milestone?.sub_stages?.at(-1)?.status === "Fulfilled"
                          ? "text-green-600"
                          : milestone?.sub_stages?.at(-1)?.status === "Active"
                            ? "text-[#083990]"
                            : "text-gray-400"
                        }`}
                    >
                      {milestone?.sub_stages?.at(-1)?.sub_stage_name}
                    </div> */}

                    <div className={`text-sm font-medium text-gray-400`}>
                      {milestone?.sub_stages?.at(-1)?.sub_stage_name}
                    </div>

                    {milestone?.sub_stages?.at(-1) && (
                      <div className="text-sm text-gray-600">
                        {milestone?.sub_stages?.at(-1)?.description ||
                          milestone?.sub_stages?.at(-1)?.sub_stage_name}
                      </div>
                    )}
                    <div className="text-xs text-gray-400">
                      {milestone?.sub_stages?.at(-1)?.created_at
                        ? new Date(
                            milestone?.sub_stages?.at(-1)?.created_at as number
                          ).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : ""}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
